module.exports = __webpack_public_path__ + "media/recipes/128-db6c8cd4.png";